export default __webpack_public_path__ + "static/media/pants-short-3.175a19e2.png";